<template>
    <div>
        <div v-loading="loading" class="describe-container">
            <zm-form label-position="left" class="describe-form" v-if="Object.keys(data).length">
                <zm-form-item label="groupId">
                    {{ data.groupId }}
                    <zm-button size="small" type="primary" plain @click="showReset" v-if="!isTopicDetail && hasPermission">Reset</zm-button>
                </zm-form-item>
                <zm-form-item label="coordinator">
                    {{ data.coordinator.id }}_{{ data.coordinator.host }}
                </zm-form-item>
                <zm-form-item label="partitionAssignor">
                    {{ data.partitionAssignor }}
                </zm-form-item>
                <zm-form-item label="state">
                    {{ data.state }}
                </zm-form-item>
                <zm-form-item label="totalLag">
                    {{ data.totalLag }}
                </zm-form-item>
            </zm-form>
            <zm-button size="small" type="primary" title="reset topic remain" @click="showResetV3()"
            v-if="isTopicDetail && hasPermission">Reset Topic Remain</zm-button>
            <zm-input size="small" v-model.trim="search" v-if="data.members"
                class="search-input" placeholder="input to search"></zm-input>
            <zm-table
                :data="tableData.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)"
                resizable border v-if="data.members" @sort-change="onSort">
                <zm-table-column prop="topicUrl" label="topicUrl" :show-overflow-tooltip="true"></zm-table-column>
                <zm-table-column prop="partition" label="partition" sortable></zm-table-column>
                <zm-table-column prop="currentOffset" label="currentOffset"></zm-table-column>
                <zm-table-column prop="logEndOffset" label="logEndOffset"></zm-table-column>
                <zm-table-column prop="lag" label="lag" sortable></zm-table-column>
                <zm-table-column prop="memberId" label="memberId" :show-overflow-tooltip="true"></zm-table-column>
                <zm-table-column prop="host" label="host" :show-overflow-tooltip="true"></zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap" v-if="data.members">
                <zm-pagination @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-size="pageable.pageSize"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="tableData.length">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :visible.sync="visible" title="Reset Topic Remain" append-to-body>
            <zm-form :model="resetForm" label-position="left" ref="form">
                <zm-form-item label="topicUrl" label-width="100px">
                    <div slot="label">
                        <tip label="topicUrl" id="group-resettopic-topicUrl"></tip>
                    </div>
                    <zm-select size="small" v-model="resetForm.topicUrl" filterable clearable>
                        <zm-option v-for="item in topicList" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="" label-width="0">
                    <zm-checkbox size="small" v-model="resetForm.resetToEarliest">
                        <tip label="resetToEarliest" id="group-resettopic-resetToEarliest"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="resetTopicRemain()" :loading="loading">Reset</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :visible.sync="visibleV3" title="Reset Topic Remain" append-to-body>
            <zm-button size="small" @click="addParam" icon="zm-icon-add" type="primary"
            v-if="!resetFormV3TopicList.length">add topic</zm-button>
            <zm-table :data="resetFormV3TopicList" max-height="300" v-if="resetFormV3TopicList.length">
                <zm-table-column prop="key" label="topic">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">{{ scope.row.key }}</span>
                        <zm-select size="small" v-model="scope.row.key" v-else filterable clearable>
                            <zm-option v-for="item in selectableKeys" :key="item.key"
                                :value="item" :label="item"></zm-option>
                        </zm-select>
                    </template>
                </zm-table-column>
                <zm-table-column prop="value" label="partition">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">
                            <zm-tag v-for="item in scope.row.value" :key="item" type="">{{ item }}</zm-tag></span>
                        <zm-select size="small" multiple v-model="scope.row.value" v-else
                        :checkbox-options="resetFormV3TopicOption.partition[scope.row.key]"></zm-select>
                    </template>
                </zm-table-column>
                <zm-table-column width="130px">
                        <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                    </template>
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                            @click="scope.row.isEdit = false" :disabled="!scope.row.key.length"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-delete"
                            @click="deleteParam(scope.row.key)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <zm-form :model="resetFormV3" :rules="rules" label-position="left" ref="resetFormV3" label-width="100px" style="margin-top: 10px">
                <zm-form-item label="resetStrategy" prop="resetStrategy">
                    <div slot="label">
                        <tip label="resetStrategy" id="group-resetv3-resetStrategy"></tip>
                    </div>
                    <zm-select size="small" v-model="resetFormV3.resetStrategy" filterable clearable>
                        <zm-option v-for="item in resetStrategyList" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="offset" v-if="resetFormV3.resetStrategy === 'TO_OFFSET'">
                    <div slot="label">
                        <tip label="offset" id="group-resetv3-offset"></tip>
                    </div>
                    <zm-input-number size="small" v-model="resetFormV3.offset" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="datetime" v-if="resetFormV3.resetStrategy === 'TO_DATETIME'">
                    <div slot="label">
                        <tip label="datetime" id="group-resetv3-datetime"></tip>
                    </div>
                    <zm-date-picker size="small" v-model="resetFormV3.datetime" type="datetime" value-format="yyyy-MM-ddTHH:mm:ss.000"></zm-date-picker>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visibleV3 = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="resetTopicRemainV3()" :loading="loading">Reset</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getGroupDescribe, getChannelTopics, resetTopicRemainV2, resetTopicRemainV3 } from '../../api/index'
import tip from 'components/ToolTip/index'
export default {
    name: 'groupDescribe',
    components: {
        tip
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false,
            data: {},
            search: '',
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            },
            visible: false,
            topicList: [],
            resetStrategyList: ['TO_EARLIEST', 'TO_LATEST', 'TO_OFFSET', 'TO_DATETIME'],
            visibleV3: false,
            resetFormV3TopicOption: {
                topic: [],
                partition: {}
            },
            resetFormV3TopicList: [],
            resetFormV3: {
                channelId: '',
                groupId: '',
                resetStrategy: '',
                offset: 0,
                datetime: '',
                topics: []
            },
            resetForm: {
                channelId: '',
                group: '',
                topicUrl: '',
                resetToEarliest: false
            },
            rules: {
                resetStrategy: [
                    { required: true, message: 'please select resetStrategy', trigger: 'blur' }
                ]
            }
        }
    },
    props: ['channelId', 'groupId', 'isTopicDetail'],
    created () {
        this.fetchDescribe()
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.data.members.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search) > -1
                    })
                })
            }
            return this.data.members
        },
        selectableKeys () {
            let data = JSON.parse(JSON.stringify(this.resetFormV3TopicOption.topic))
            this.resetFormV3TopicList.map(item => {
                if (item.key && data.indexOf(item.key) !== -1) {
                    data.splice(data.indexOf(item.key), 1)
                }
            })
            return data
        },
        addDisabled () {
            let data = false
            this.resetFormV3TopicList.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        }
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.data.members.sort((a, b) => {
                if (a[prop] > b[prop]) {
                    return descending ? -1 : 1
                } else if (a[prop] < b[prop]) {
                    return descending ? 1 : -1
                } else {
                    return 0
                }
            })
        },
        fetchDescribe (selectedGroup) {
            this.loading = true
            if (selectedGroup) {
                this.groupId = selectedGroup
            }
            getGroupDescribe(this.channelId, this.groupId).then(response => {
                this.loading = false
                this.data = response
                this.resetFormV3TopicOption.topic = []
                this.resetFormV3TopicOption.partition = {}
                Object.keys(this.data.topicPartitions).map(item => {
                    this.resetFormV3TopicOption.topic.push(item)
                    this.resetFormV3TopicOption.partition[item] = []
                    this.data.topicPartitions[item].map(par => {
                        this.resetFormV3TopicOption.partition[item].push({
                            value: par,
                            label: par
                        })
                    })
                })
            }).catch(() => {
                this.loading = false
            })
        },
        showResetV3 () {
            this.visibleV3 = true
            this.resetFormV3.channelId = this.channelId
            this.resetFormV3.groupId = this.groupId
            this.resetFormV3.resetStrategy = ''
            this.resetFormV3.offset = 0
            this.resetFormV3.datetime = ''
            this.resetFormV3.topics = []
        },
        resetTopicRemainV3 () {
            this.resetFormV3.topics = []
            this.resetFormV3TopicList.map(item => {
                var str = item.key
                item.value.map((v, i) => {
                    str += i ? ',' + v : ':' + v
                })
                this.resetFormV3.topics.push(str)
            })
            this.loading = true
            resetTopicRemainV3(this.resetFormV3).then(response => {
                this.loading = false
                if (response.success) {
                    this.$message({
                        type: 'success',
                        message: 'Reset success'
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: response.errorMsg
                    })
                }
                this.visibleV3 = false
            }).catch(() => {
                this.loading = false
            })
        },
        resetTopicRemain () {
            this.loading = true
            resetTopicRemainV2(this.resetForm).then(response => {
                this.loading = false
                if (response.success) {
                    this.$message({
                        type: 'success',
                        message: 'Reset success'
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: response.errorMsg
                    })
                }
                this.visible = false
            }).catch(() => {
                this.loading = false
            })
        },
        showReset () {
            this.resetForm.channelId = this.channelId
            this.resetForm.group = this.groupId
            this.fetchTopic()
            this.visible = true
        },
        fetchTopic () {
            getChannelTopics(this.channelId).then(response => {
                this.topicList = response
            })
        },
        addParam () {
            this.resetFormV3TopicList.unshift({
                key: '',
                value: [],
                isEdit: true
            })
        },
        deleteParam (key) {
            if (key) {
                this.resetFormV3TopicList.map((item, index, arr) => {
                    if (item.key === key) {
                        this.resetFormV3TopicList.splice(index, 1)
                    }
                })
            } else {
                this.resetFormV3TopicList.shift()
            }
        }
    }
}
</script>
<style scoped>
.describe-form {
    margin: 10px;
    color: #747487;
    padding-right: 80px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
    /* padding-right: 80px; */
}
.describe-container {
    min-height: 300px;
}
</style>
